import React from 'react';

import MapControlsZoomMore from './MapControlsZoom/MapControlsZoomMore';
import MapControlsZoomLess from './MapControlsZoom/MapControlsZoomLess';

import './MobileMapControls.scss';

const MobileMapControls = () => (
  <>
    <MapControlsZoomMore />
    <MapControlsZoomLess />
  </>
);

export default MobileMapControls;
